<div class="platform-admin-shell">
  <aside class="platformAdmin-sidebar" [class.platformAdmin-sidebar--open]="menuOpen()">
    <div class="platformAdmin-brand">
      <span>{{ initials() }}</span>
      <div>
        <strong>Apex Admin</strong>
        <small>{{ orgName() }}</small>
      </div>
    </div>

    <nav class="platformAdmin-nav" aria-label="Platform admin navigation">
      @for (group of navGroups; track group.label ?? 'main') {
        <div class="platformAdmin-nav__group" role="group" [attr.aria-label]="group.label || 'Main'">
          @if (group.label) {
            <span class="platformAdmin-nav__heading" aria-hidden="true">{{ group.label }}</span>
          }
          @for (item of group.items; track item.route) {
            <a
              [routerLink]="item.route"
              routerLinkActive="platformAdmin-nav__item--active"
              [routerLinkActiveOptions]="{ exact: item.route === '/dashboard' }"
              class="platformAdmin-nav__item"
              (click)="closeMenu()"
            >
              <span class="material-symbols-outlined" aria-hidden="true">{{ item.icon }}</span>
              <span class="platformAdmin-nav__label">{{ item.label }}</span>
              @if (item.soon) {
                <em class="platformAdmin-nav__soon" title="Not connected to platform data yet">Soon</em>
              }
              @if (item.route === '/account-deletions' && pendingDeletionBadge()) {
                <em class="platformAdmin-nav__badge">{{ pendingDeletionBadge() }}</em>
              }
            </a>
          }
        </div>
      }
    </nav>

    <div class="platformAdmin-sidebar__footer">
      <a routerLink="/settings" routerLinkActive="platformAdmin-nav__item--active" class="platformAdmin-nav__item" (click)="closeMenu()">
        <span class="material-symbols-outlined" aria-hidden="true">settings</span>
        <span class="platformAdmin-nav__label">Settings</span>
      </a>
      <button type="button" class="platformAdmin-nav__item" (click)="signOut()">
        <span class="material-symbols-outlined" aria-hidden="true">logout</span>
        Sign out
      </button>
    </div>
  </aside>

  <main class="platformAdmin-main">
    <header class="platformAdmin-topbar">
      <button type="button" class="platformAdmin-icon-button platformAdmin-topbar__menu" (click)="menuOpen.set(!menuOpen())" aria-label="Toggle navigation">
        <span class="material-symbols-outlined" aria-hidden="true">menu</span>
      </button>
      <div class="platformAdmin-topbar__identity">
        <strong>{{ orgName() }}</strong>
        <small>Platform operations access</small>
      </div>
      <label class="platformAdmin-search">
        <span class="material-symbols-outlined" aria-hidden="true">search</span>
        <input type="search" placeholder="Search organizations, users..." />
      </label>
      <div class="platformAdmin-topbar__actions">
        <div class="platformAdmin-notifications">
          <button
            type="button"
            class="platformAdmin-icon-button platformAdmin-notification-button"
            aria-label="Notifications"
            [attr.aria-expanded]="notificationOpen()"
            (click)="toggleNotifications()"
          >
            <span class="material-symbols-outlined" aria-hidden="true">notifications</span>
            @if (pendingDeletionBadge()) {
              <em>{{ pendingDeletionBadge() }}</em>
            }
          </button>
          @if (notificationOpen()) {
            <div class="platformAdmin-notifications__panel">
              <header>
                <strong>Notifications</strong>
                <button type="button" class="platformAdmin-notifications__close" (click)="closeNotifications()" aria-label="Close notifications">
                  <span class="material-symbols-outlined" aria-hidden="true">close</span>
                </button>
              </header>
              <a routerLink="/account-deletions" class="platformAdmin-notifications__item" (click)="closeNotifications()">
                <span class="material-symbols-outlined" aria-hidden="true">group_remove</span>
                <span>
                  <strong>{{ notificationSummary() }}</strong>
                  <small>Review account deletion requests</small>
                </span>
              </a>
            </div>
          }
        </div>
        <button type="button" class="platformAdmin-icon-button" aria-label="Help">
          <span class="material-symbols-outlined" aria-hidden="true">help</span>
        </button>
        <button type="button" class="platformAdmin-icon-button" (click)="toggleTheme()" aria-label="Toggle dark mode">
          <span class="material-symbols-outlined" aria-hidden="true">contrast</span>
        </button>
      </div>
    </header>

    <router-outlet />
  </main>
</div>
